// AWS Amplify API disabled — backend migrated to EC2. Auth still used for legacy Cognito calls.
import { Auth } from "aws-amplify";
import axios from "axios";
// import config from '../config.json';
import { OffLineAPI } from "../offline-auth/api";
import { encryptData } from "../lib/crypto";
import { getSubdomain } from "../lib/domain";
// import axios from "axios";

var _API = OffLineAPI;

let getUsersPromise;
let clinicUserReportPro;
let secpromise;
// let clinicPromise;
let detailsPromise;
// let adminPromise;
let userreportsPromise;
let apptReportPro;
let clinicapptReportPro;
let doctorReportPro;
let adminapptReportPro;
let doctorUploadsPro;
let doctorfilesPro;
let sessionPro;
let userinfoPro;
let allclinicPro;
let alladminPro;
let doctorlistPro;
let domainlistPro;
let stripePro;
let poolPro;
let deptPro;

export async function getUsers(name, searchKey, token, limit, skip) {
    if (getUsersPromise) {
        _API.cancel(getUsersPromise, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");

    let query = `consultRole=${name}`;
    query += token && token !== null && token !== "" ? `&token=${JSON.stringify(token)}` : "";
    query += searchKey && searchKey !== null && searchKey !== "" ? searchKey : "";
    query += limit ? `&limit=${limit}` : `&limit=10`;
    query += skip ? `&skip=${skip}` : `&skip=0`;
    query += `&query=${atoken}`;
    getUsersPromise = _API.get("users", `/users?${query}`);
    return getUsersPromise;
}

export async function getClinicsByEmail(email) {
    if (!email) {
        throw new Error("email is required");
    }
    const base = process.env.REACT_APP_usersGateway;
    if (!base) {
        throw new Error("users gateway url not configured");
    }
    return axios.get(`${base}/getclinicsbyemail`, {
        params: { email },
        headers: {
            origin: window.location.origin,
        },
    });
}
// export function getClinics() {
//     if (clinicPromise) {
//         _API.cancel(clinicPromise, "API canceled");
//     }
//     let query = `consultRole=clinic`;
//     //  query += limit ? `&limit=${limit}` : `&limit=10`
//     clinicPromise = _API.get("users", `/userslist?${query}`);
//     return clinicPromise;
// }
export async function getUserDetails(id) {
    if (detailsPromise) {
        _API.cancel(detailsPromise, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    detailsPromise = _API.get("users", `/userdetails?userId=${id}&query=${atoken}`);
    return detailsPromise;
}

export async function getUserCertificates(id) {
    console.log("Fetching certificates for user:", id);
    const atoken = localStorage.getItem("secureid_access_token");
    console.log("Access Token:", atoken);
    try {
        detailsPromise = _API.get("users", `/userdetails?userId=${id}&query=${atoken}`);
        console.log("API call made:", detailsPromise);
        return detailsPromise;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
}

export async function updatProfilePic(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("users", `/profilepic?query=${atoken}`, { body });
}
export function createPatient(body) {
    return _API.post("users", `/createpatient`, { body });
}

export async function updateProfile(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("users", `/updateconsultuser?query=${atoken}`, { body });
}

export async function updateDoctorLicense(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("users", `/updatedoctorlicense?query=${atoken}`, { body });
}

export async function deleteCertificate(id, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    let query = `_id=${id}`;
    query += `&query=${atoken}`;
    return _API.put("users", `/deletecertificates?${query}`, { body });
}

export async function deletePatient(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("users", `/deleteuser?query=${atoken}`, { body });
}

export async function createcoupon(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/coupon?query=${atoken}`, { body });
}

export async function getcoupon() {
    const userId = localStorage.getItem("sub");
    return _API.get("admin", `/coupon/${userId}`);
}
export async function deletecoupon(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.del("admin", `/coupon?query=${atoken}`, { body });
}
export async function updatecoupon(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("admin", `/coupon?query=${atoken}`, { body });
}

export async function validatecoupon(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/validate?query=${atoken}`, { body });
}

export async function getallcoupon({ clinicId, doctorId }) {
    const atoken = localStorage.getItem("secureid_access_token");
    const queryParams = new URLSearchParams();
    queryParams.append("clinicId", clinicId);
    queryParams.append("doctorId", doctorId);
    queryParams.append("query", atoken); // sending token as separate query param

    return _API.get("admin", `/getallcoupon?${queryParams.toString()}`);
}

// export function adminDashboard() {
//     if (adminPromise) {
//         _API.cancel(detailsPromise, "API canceled");
//     }
//     adminPromise = _API.get("admin", `/admindashboard`);
//     return adminPromise
// }
export async function adminUserReport() {
    if (userreportsPromise) {
        _API.cancel(userreportsPromise, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    userreportsPromise = _API.get("admin", `/adminuserreport?query=${atoken}`);
    return userreportsPromise;
}
export async function clinicUserReport(type = "all") {
    if (clinicUserReportPro) {
        _API.cancel(clinicUserReportPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    clinicUserReportPro = _API.get("admin", `/clinicuserreport?query=${atoken}&type=${type}`);
    return clinicUserReportPro;
}
export async function adminAppointmentReport() {
    if (apptReportPro) {
        _API.cancel(apptReportPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    apptReportPro = _API.get("admin", `/adminappointmentreport?query=${atoken}`);
    return apptReportPro;
}

export async function getfeedback(id) {
    if (detailsPromise) {
        _API.cancel(detailsPromise, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    detailsPromise = _API.get("users", `/getfeedback/${id}?query=${atoken}`);
    return detailsPromise;
}

export async function updatedocument(userId, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    if (!userId) {
        throw new Error("User ID is missing");
    }
    return _API.put("admin", `/updatedoctordoc/${userId}?query=${atoken}`, {
        body,
    });
}

export async function updatedoctor(userId, body, documentType) {
    const atoken = localStorage.getItem("secureid_access_token");
    if (!userId) {
        throw new Error("User ID is missing");
    }
    return _API.put("admin", `/updatedoctor/${userId}?query=${atoken}`, {
        body: { ...body, documentType },
    });
}

export async function clinicAppointmentReport() {
    if (clinicapptReportPro) {
        _API.cancel(clinicapptReportPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    clinicapptReportPro = _API.get("admin", `/clinicappointmentreport?query=${atoken}`);
    return clinicapptReportPro;
}
export async function createUser(body, data) {
    if (process.env.REACT_APP_isOffline === "true") {
        return _API.post("admin", `/usersignup`, { body });
    } else {
        if (data) {
            const atoken = localStorage.getItem("secureid_access_token");
            return _API.post("admin", `/clinicCreateUser?query=${atoken}`, { body });
        }
        return _API.post("admin", `/adminuser`, { body });
    }
}

export async function adminDoctorReport(stateName, city, from, to, token, limit) {
    if (doctorReportPro) {
        _API.cancel(doctorReportPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    let query = `stateName=${stateName}&city=${city}&from=${from}&to=${to}`;
    query += token && token !== "" && token !== null ? `&token=${JSON.stringify(token)}` : "";
    query += limit ? `&limit=${limit}` : `&limit=10`;
    query += `&query=${atoken}`;
    doctorReportPro = _API.get("admin", `/admindoctorreport?${query}`);
    return doctorReportPro;
}

export async function adminAppointmentReports(role, from, to, token, limit) {
    if (adminapptReportPro) {
        _API.cancel(adminapptReportPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    let query = `role=${role}&from=${from}&to=${to}`;
    query += token && token !== "" && token !== null ? `&token=${JSON.stringify(token)}` : "";
    query += limit ? `&limit=${limit}` : `&limit=10`;
    query += `&query=${atoken}`;
    adminapptReportPro = _API.get("admin", `/adminappointmentreportbyrole?${query}`);
    return adminapptReportPro;
}
export async function updateUser(id, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("admin", `/updateuser/${id}?query=${atoken}`, { body });
}

export async function deleteUser(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/deleteuser?query=${atoken}`, { body });
}
export async function getDoctorUploadFiles() {
    if (doctorUploadsPro) {
        _API.cancel(doctorUploadsPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    doctorUploadsPro = _API.get("users", `/doctoruploadlist?query=${atoken}`);
    return doctorUploadsPro;
}
export async function getDoctorFiles(doctorId, clinicId) {
    if (doctorfilesPro) {
        _API.cancel(doctorfilesPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    doctorfilesPro = _API.get("users", `/doctoruploadlist?doctorId=${doctorId}&clinicId=${clinicId}&query=${atoken}`);
    return doctorfilesPro;
}

export async function deletewaitingroomupload(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("users", `/deletewaitingroomupload?query=${atoken}`, { body });
}

export async function updatedoc(userId, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.put("admin", `/updatedoctordoc/${userId}?query=${atoken}`, { body });
}

export function patientsignup(body) {
    return _API.post("users", `/patientsignup`, { body });
}

export async function getPrevent() {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.get("users", `/prevent?query=${atoken}`);
}
export function postPrevent(body) {
    let data = body?.type === "change" && { body: encryptData(body) };
    return _API.post("users", "/prevent", body?.type === "change" ? { body: data } : { body });
}

export async function createroom(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    // let body = {
    // roomName: 'testfordemo',
    // roomOptions: {
    //     inputLimit : 10,
    //     participantLimit : 10,
    // },
    // roomType: 'C',
    // userEmail: 'venkatesh.t@peoplelinkvc.com',
    // expireAt: 1639035099641

    // }
    return _API.post("admin", `/createroom?query=${atoken}`, { body });
}
export function login(body) {
    return _API.post("users", `/login`, { body });
}

export function currentsession() {
    if (sessionPro) {
        _API.cancel(sessionPro, "API canceled");
    }
    sessionPro = _API.get("users", `/currentsession`);
    return sessionPro;
}

export async function currentuserinfo(userId = null) {
    if (userinfoPro) {
        _API.cancel(userinfoPro, "API canceled");
    }
    const token = localStorage.getItem("secureid_access_token") || localStorage.getItem("token");

    let path = process.env.REACT_APP_isOffline === "true" ? `/currentuserinfo` : `/currentuserinfo?query=${token}`;
    userinfoPro = _API.get("users", path);
    return userinfoPro;
}

export function getallClinics(qr = null) {
    if (allclinicPro) {
        _API.cancel(allclinicPro, "API canceled");
    }
    let query = `consultRole=clinic`;
    if (qr !== null) {
        query += `&${qr}`;
    }
    //  query += limit ? `&limit=${limit}` : `&limit=10`
    allclinicPro = _API.get("users", `/listallclinics?${query}`);
    return allclinicPro;
}

export function changepasword(body) {
    return _API.put("users", `/changepassword`, { body });
}

export function resetpassword(body) {
    return _API.put("users", `/defaultpassword`, { body });
}

export async function verifyuser(body) {
    const token = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/verifyuser?query=${token}`, { body });
}
export function forgotPassword(body) {
    return _API.post("users", `/sendotp`, { body });
}
export function forgotPasswordSubmit(body) {
    return _API.post("users", `/validateotp`, { body });
}

export function deletefiles(body) {
    return _API.post("users", `/deletefile`, { body });
}

export function getAllAdmins() {
    if (alladminPro) {
        _API.cancel(alladminPro, "API canceled");
    }
    let query = `consultRole=clinicAdmin`;
    //  query += limit ? `&limit=${limit}` : `&limit=10`
    alladminPro = _API.get("users", `/listallclinics?${query}`);
    return alladminPro;
}

export async function getDoctorList(
    name,
    filterDate,
    from,
    fromTime,
    to,
    days,
    token,
    clinicId,
    limit = 10,
    searchKey,
    skip,
    deptId,
    specialityId
) {
    if (doctorlistPro) {
        _API.cancel(doctorlistPro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    let query = filterDate ? `consultRole=${name}&filterDate=${filterDate}` : `consultRole=${name}`;
    query += `&limit=${limit}&from=${from}&fromTime=${fromTime}&to=${to}&days=${days}&clinicId=${clinicId}&searchKey=${searchKey}&skip=${skip}`;
    if (deptId) query += `&deptId=${deptId}`;
    if (specialityId) query += `&specialityId=${specialityId}`;
    query += token && token !== null && token !== "" ? `&token=${JSON.stringify(token)}` : "";
    query += `&query=${atoken}`;
    // return _API.get("users", `/users?${query}`);  old API
    doctorlistPro = _API.get("users", `/optimizedusers?${query}`); //optimised api
    return doctorlistPro;
}

export function checkDomain(username, domain) {
    if (domain && domain.subdomain && domain.hostname !== "localhost") {
        let body = { username, domain: domain.subdomain };
        return _API.post("users", `/domainconfirmation`, { body });
    } else {
        return { status: true };
    }
}

export function deleteProfilePic(body) {
    return _API.post("users", "/deleteprofile", { body });
}

export function sendfeedback(body) {
    return _API.post("users", "/feedback", { body });
}

export async function getDomainDetials(domain) {
    if (domainlistPro) {
        _API.cancel(domainlistPro, "API canceled");
    }
    /* The above code is using the AWS Amplify library to authenticate a user and retrieve an access token. */
    const atoken = localStorage.getItem("secureid_access_token");
    domainlistPro = _API.get("admin", `/listdomain?subdomain=${domain}&query=${atoken}`);
    return domainlistPro;
}

export async function getStipeDetials(userId) {
    if (stripePro) {
        _API.cancel(stripePro, "API canceled");
    }
    const atoken = localStorage.getItem("secureid_access_token");
    stripePro = _API.get("admin", `/liststripe/${userId}?query=${atoken}`);
    return stripePro;
}

export async function updateStripeDetails(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/stripecreate?query=${atoken}`, { body });
}

export function getPoolDetials(userId) {
    if (poolPro) {
        _API.cancel(poolPro, "API canceled");
    }
    poolPro = _API.get("admin", `/listpool/${userId}`);
    return poolPro;
}

export function updatePoolDetails(body) {
    return _API.post("admin", `/poolcreate`, { body });
}

export async function updateDomainDetails(domain, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/stripe/${domain}?query=${atoken}`, { body });
}
export async function saveLogo(domain, body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/savelogo/${domain}?query=${atoken}`, { body });
}
export async function deleteStripeDetails(subdomain) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.del("admin", `/deletestripe?subdomain=${subdomain}&query=${atoken}`, {});
}

export function getDepartmentList() {
    if (deptPro) {
        _API.cancel(deptPro, "API canceled");
    }
    deptPro = _API.get("users", `/departmentlist`);
    return deptPro;
}
export function getSpecializationList() {
    // if (secpromise) {
    //     _API.cancel(secpromise, "MY cancelation");
    // }
    secpromise = _API.get("users", `/specializationlist`);
    return secpromise;
}

export async function deleteLogo(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.del("admin", `/deletelogo?query=${atoken}`, { body });
}

export function getDomainData(subdomain) {
    return new Promise((resolve, reject) => {
        fetch(`${process.env.REACT_APP_usersGateway}/domainlist/${subdomain}`)
            .then((res) => res.json())
            .then(
                (result) => {
                    resolve(result);
                },
                (error) => {
                    console.log("error in domain api === ", error);
                    resolve(null);
                }
            );
    });
}

export async function DisableEnable(body) {
    const atoken = localStorage.getItem("secureid_access_token");
    return _API.post("admin", `/disableEnable?query=${atoken}`, { body });
}

export function getMcuToken(room, user, role) {
    return _API.get("admin", `mcutoken/${room}/${user}/${role}`);
}

export function createClinic(body) {
    return _API.post("users", `/clinicsignup`, { body });
}

// --- SecureID auth actions ---

// We proxy through our inclinic backend (auth.routes.js mounts at /auth) to
// dodge browser→SecureID CORS. Derive the /auth base from the existing
// /users gateway by swapping the trailing segment.
const SECUREID_API_BASE = (process.env.REACT_APP_usersGateway || "").replace(/\/users\/?$/, "/auth");

// Auth endpoints must never carry a stale Bearer token and must never
// trigger the refresh dance — otherwise a failed login causes an
// interceptor deadlock that hangs the spinner.
const isAuthEndpoint = (url = "") =>
    /\/auth\/(password-login|refresh|logout|forgot-password|reset-password)\b/.test(url) ||
    // Public, unauthenticated flows that now live off the API root (no /auth
    // prefix). Treat them as auth endpoints so the interceptor never attaches a
    // stale token or runs the 401 refresh dance against them.
    /\/(forgot-password|reset-password)\b/.test(url);

// Current clinic subdomain — the backend subdomain middleware needs this on
// every request (incl. login) to resolve the tenant. getSubdomain falls back
// to "app" for localhost / apex domains.
const getClinicSubdomain = () => {
    try {
        return getSubdomain(window.location.hostname).subdomain;
    } catch (e) {
        return process.env.REACT_APP_subdomain || "app";
    }
};

// Auto-attach SecureID token to every axios request when present.
// Cognito-bound calls go through Amplify _API and are unaffected.
axios.interceptors.request.use((config) => {
    config.headers = config.headers || {};
    // X-Clinic-Subdomain goes on EVERY request — including auth/login —
    // so the backend subdomain middleware can resolve the tenant. The
    // server CORS config explicitly whitelists this header.
    if (!config.headers["X-Clinic-Subdomain"]) {
        config.headers["X-Clinic-Subdomain"] = getClinicSubdomain();
    }
    if (isAuthEndpoint(config?.url)) return config;
    const token = typeof window !== "undefined" && localStorage.getItem("secureid_access_token");
    if (token && !config.headers?.Authorization) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // tenantId resolves the tenant on the backend — sourced from the
    // currentuserinfo response and persisted in localStorage.
    const tenantId = typeof window !== "undefined" && localStorage.getItem("tenantId");
    if (tenantId && !config.headers["tenantId"]) {
        config.headers["tenantId"] = tenantId;
    }
    return config;
});

// On 401, try one silent refresh; if that fails, clear tokens.
let refreshing = null;
axios.interceptors.response.use(
    (r) => r,
    async (error) => {
        const original = error.config;
        if (
            error?.response?.status === 401 &&
            !original?._retried &&
            !isAuthEndpoint(original?.url) &&
            localStorage.getItem("secureid_access_token")
        ) {
            original._retried = true;
            try {
                if (!refreshing)
                    refreshing = secureIdRefresh().finally(() => {
                        refreshing = null;
                    });
                await refreshing;
                const newToken = localStorage.getItem("secureid_access_token");
                if (newToken) {
                    original.headers.Authorization = `Bearer ${newToken}`;
                    return axios(original);
                }
            } catch (e) {
                localStorage.removeItem("secureid_access_token");
                localStorage.removeItem("secureid_id_token");
            }
        }
        return Promise.reject(error);
    }
);

// Backend response envelope is { status, data: <SecureID payload> }
const unwrap = (res) => (res?.data && "data" in res.data ? res.data.data : res?.data);

export async function secureIdLogin({ email, password }) {
    const res = await axios.post(`${SECUREID_API_BASE}/password-login`, { email, password }, { withCredentials: true });
    const payload = unwrap(res);
    if (payload?.accessToken) {
        localStorage.setItem("secureid_access_token", payload.accessToken);
        if (payload.idToken) localStorage.setItem("secureid_id_token", payload.idToken);
    }
    return payload;
}

export async function secureIdRefresh() {
    const res = await axios.post(`${SECUREID_API_BASE}/refresh`, {}, { withCredentials: true });
    const payload = unwrap(res);
    if (payload?.accessToken) {
        localStorage.setItem("secureid_access_token", payload.accessToken);
    }
    return payload;
}

export async function secureIdLogout() {
    try {
        await axios.post(`${SECUREID_API_BASE}/logout`, {}, { withCredentials: true });
    } finally {
        localStorage.removeItem("secureid_access_token");
        localStorage.removeItem("secureid_id_token");
        localStorage.removeItem("tenantId");
    }
}

export function secureIdRedirectLogin() {
    // OAuth redirect flow not used in proxy mode; surface a clear error.
    console.warn("secureIdRedirectLogin: OAuth redirect requires direct SecureID call (not proxied).");
}

// SecureID self-service password recovery. Both endpoints are public (no
// Bearer token) — isAuthEndpoint() above keeps the interceptor from attaching
// a stale token or triggering the refresh dance.

// Step 1: request a reset email. SecureID always returns the same 200 message
// whether or not the email exists, so we never leak which addresses are
// registered. The email contains a link to /reset-password?token=...
export async function secureIdForgotPassword({ email }) {
    const res = await axios.post(`${SECUREID_API_BASE}/forgot-password`, { email }, { withCredentials: true });
    return unwrap(res);
}

// Step 2: consume the token from the reset email and set a new password.
// Token is valid for 60 minutes and single-use.
export async function secureIdResetPassword({ token, password }) {
    // Route is `/reset-password` off the API root (NOT under /auth). Token comes
    // from the email link's query param; token + password go in the body.
    const res = await axios.post(`${SECUREID_API_BASE}/reset-password`, { token, password }, { withCredentials: true });
    return unwrap(res);
}

export function updatePaymentStatus(body) {
    return _API.post("users", `/updatepayment`, { body });
}

export function getLicenseStatus(phone) {
    return _API.get("users", `/licensestatus?phone=${phone}`);
}

export function getClinicLicenceByEmail(email) {
    return _API.get("users", `/getUserByEmail?email=${email}`);
}

export function getUnlicencedData(query) {
    return _API.get("users", `/getClinicDataByPhone${query}`);
}

export const getDomainDetails = (subdomain) => {
    return API.get("users", `/domainlist/${subdomain}`);
};

export const reconfirmApi = (body) => {
    return API.post("users", `/userReconfirm`, { body });
};

export const sessionSignOut = (query) => {
    return API.get("users", `/sessionsignout?query=${encodeURIComponent(query)}`);
};

// export async function sessionSignOut(query) {
//     let data = {};
//    await  axios({
//         method: 'get',
//         url: `http://localhost:6102/sessionsignout?token=${query}`,
//         responseType: 'stream'
//     })
//         .then((response) => {
//             console.log("..................", response)
//             data = response
//             // console.log("...............:", data)
//         }).catch(
//             (error) => {
//                 console.log('errrrr......', error)
//             }
//     )
//     // console.log(".....ygdqwugqdyutgqdwyuwtuy..:", data)
//     return data
// }
